<template lang='pug'>
  .jumbotron.bgwhite
    .container
      img.img-fluid.mx-auto.d-block(src='~@/assets/header.jpg')
</template>

<script>
export default {
  name: 'HomeBanner'
};
</script>

<style scoped>
  .bgwhite {
    background-color: #ffffff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeBanner.vue